/*eslint perfectionist/sort-objects: "error"*/
export const TEST_IDS = {
  accountDetailsBreadcrumb: "account-details-breadcrumb",
  accountIdentificationsCardAccountNumber:
    "cash-management-account-details-account-number",
  accountIdentificationsCardAuAccountNumber:
    "account-identifications-card-au-account-number",
  accountIdentificationsCardBsb: "account-identifications-card-bsb",
  accountIdentificationsCardIban: "cash-management-account-details-iban",
  accountIdentificationsCardSortCode: "cash-management-account-details-routing",
  accountIdentificationsCardSwiftBic:
    "cash-management-account-details-swift-bic",
  accountIdentificationsCardWalletId: "cash-management-wallet-id-content",
  accountIdentifierCardAccountStatus: "cash-management-account-status",
  accountIdentifierCardId: "account-identifier-card-id",
  accountIdentifierCardNickname: "cash-management-account-nickname",
  accountsBreadcrumb: "accounts-breadcrumb",
  companyUuid: "cash-management-account-company-uuid",
  companyUuidClipboardButton:
    "cash-management-account-company-uuid-clipboard-button",
  configureNotificationsButton: "configure-notifications",
  connectBreadcrumb: "connect-nav-link",
  createAccountAccountNumber: "account-account-number",
  createAccountBreadcrumb: "create-account-breadcrumb",
  createAccountFormAuAccountNumber: "account-account-number",
  createAccountFormBsb: "bsb",
  createAccountFormCurrency: "account-currencies",
  createAccountFormEnableSettlementModelLabel:
    "account-instruct-settlement-batches",
  createAccountFormEnableSettlementModelToggle:
    "cash-management-provider-settlement",
  createAccountFormIban: "account-iban",
  createAccountFormMasterAccountNumber:
    "cash-management-banking-circle-master-account-number",
  createAccountFormNickname: "account-nickname",
  createAccountFormProvider: "cash-management-provider",
  createAccountFormSwiftBic: "account-swift-bic",
  createAccountFormVoltAccountId: "volt-cash-management-bank-volt-account-id",
  createAccountFormWalletId: "cash-management-wallet-id",
  createAccountOpenProviderConfiguration: "button-go-provider-edit",
  createAccountRouting: "account-routing",
  getProviderConfigListProvider: (providerName: string) =>
    `cash-management-configurable-providers-${providerName}`,
  getProviderConfigListProviderConfigured: (providerName: string) =>
    `cash-management-configurable-providers-${providerName}-configured`,
  getProviderConfigListProviderNotConfigured: (providerName: string) =>
    `cash-management-configurable-providers-${providerName}-not-configured`,
  goBackToConnectSettingsLink: "go-back-to-connect-settings-link",
  isxDomain: "isx-domain",
  isxHmacKey: "isx-hmac-key",
  isxMerchantId: "isx-merchant-id",
  isxNotificationSecret: "isx-notification-secret",
  isxPayoutConfigurationBreadcrumb: "isx-payout-configuration-nav-link",
  isxPrivateKey: "isx-private-key",
  isxSubDomain: "isx-sub-domain",
  locationAndAcceptedPaymentsCardCountry:
    "cash-management-account-location-and-accepted-payments-country",
  locationAndAcceptedPaymentsCardCurrency:
    "cash-management-account-location-and-accepted-payments-currency",
  masterAccountNumber: "cash-management-account-provider-iban-content",
  masterAccountNumberClipboardButton:
    "cash-management-account-provider-iban-clipboard-button",
  masterAccountNumberField:
    "cash-management-banking-circle-master-account-number",
  providerCardBankingCircleMasterAccountNumber:
    "cash-management-account-provider-iban-content",
  providerCardProviderId: "cash-management-account-provider-id-content",
  providerCardProviderName: "cash-management-account-provider-name",
  providerCardVoltCashManagementVoltAccountId:
    "volt-cash-management-bank-volt-account-id",
  providerConfigCardNotificationSecret:
    "cash-management-config-notificationSecret",
  providerConfigCardRiskScore: "cash-management-config-riskScore",
  providerConfigCardSkeleton: "provider-config-card-skeleton",
  providerConfigDetailsBreadcrumb: "breadcrumb-provider-config-details",
  providerConfigDetailsEditButton: "button-edit-provider",
  providerConfigListBreadcrumb: "breadcrumb-provider-config-list",
  reportNotificationsCard: "cash-management-report-notifications-title",
  reportNotificationsCardActiveToggle: "switch-label",
  reportNotificationsCardConfigureButton: "configure-notifications",
  reportNotificationsCardFailingNotificationsEmail:
    "cash-management-report-notifications-alert-email",
  reportNotificationsCardNotificationsSecret:
    "cash-management-report-notifications-secret",
  reportNotificationsCardNotificationsUrl:
    "cash-management-report-notifications-url",
  reportNotificationsCardStatus: "report-notifications-card-status",
  reportNotificationsFormFailedEmail: "notifications-setting-failed-email",
  reportNotificationsFormUrl: "notifications-setting-url",
  reportNotificationsSettings: "breadcrumb-notifications",
  reportNotificationsStatusDisabled:
    "cash-management-report-notifications-status-disabled",
  reportNotificationsStatusEnabled:
    "cash-management-report-notifications-status-enabled",
  reportNotificationStatusTag:
    "cash-management-report-notifications-status-not-configured",
  settlementModelCardEnableSettlementBatches:
    "settlement-model-card-enable-settlement-batches",
  settlementModelCardTagDisabled:
    "cash-management-account-settlement-model-automatic-enabled",
  settlementModelCardTagEnabled:
    "cash-management-account-settlement-model-automatic-enabled",
  triggerSettlementBatchesButton: "submit-settlement-batch",
  voltCashManagementBankVoltAccountId:
    "volt-cash-management-bank-volt-account-id",
  voltCashManagementBankVoltAccountIdClipboardButton:
    "volt-cash-management-bank-volt-account-id-clipboard-button",
  walletId: "cash-management-wallet-id-content",
  walletIdClipboardButton: "cash-management-wallet-id-clipboard-button",
} as const;
